import React from 'react';

export const TermsOfService: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-900 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-100 mb-8">Terms of Service</h1>
        
        <div className="prose prose-invert">
          <p className="text-gray-300">Last updated: {new Date().toLocaleDateString()}</p>
          
          <section className="mt-8">
            <h2 className="text-2xl font-semibold text-gray-100 mb-4">1. Agreement to Terms</h2>
            <p className="text-gray-300">
              By accessing or using our services, you agree to be bound by these Terms of Service. If you
              disagree with any part of the terms, you may not access our services.
            </p>
          </section>

          <section className="mt-8">
            <h2 className="text-2xl font-semibold text-gray-100 mb-4">2. Use of Services</h2>
            <p className="text-gray-300">
              Our services are provided "as is" and "as available." You agree to use the services only
              for lawful purposes and in accordance with these Terms of Service.
            </p>
            <ul className="list-disc pl-6 mt-2 text-gray-300">
              <li>You must not use the services in any way that causes damage to the services or impairs availability</li>
              <li>You are responsible for maintaining the security of your account</li>
              <li>You must not attempt to gain unauthorized access to our services</li>
            </ul>
          </section>

          <section className="mt-8">
            <h2 className="text-2xl font-semibold text-gray-100 mb-4">3. Intellectual Property</h2>
            <p className="text-gray-300">
              The service and its original content, features, and functionality are owned by us and are
              protected by international copyright, trademark, patent, trade secret, and other
              intellectual property laws.
            </p>
          </section>

          <section className="mt-8">
            <h2 className="text-2xl font-semibold text-gray-100 mb-4">4. Termination</h2>
            <p className="text-gray-300">
              We may terminate or suspend your account and bar access to the service immediately,
              without prior notice or liability, under our sole discretion, for any reason whatsoever,
              including but not limited to a breach of the Terms.
            </p>
          </section>

          <section className="mt-8">
            <h2 className="text-2xl font-semibold text-gray-100 mb-4">5. Limitation of Liability</h2>
            <p className="text-gray-300">
              In no event shall we be liable for any indirect, incidental, special, consequential or
              punitive damages, including without limitation, loss of profits, data, use, goodwill, or
              other intangible losses.
            </p>
          </section>

          <section className="mt-8">
            <h2 className="text-2xl font-semibold text-gray-100 mb-4">6. Contact Us</h2>
            <p className="text-gray-300">
              If you have any questions about these Terms of Service, please contact us at:
              trycreatorform@gmail.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}; 